import dayjs from "dayjs";
import {
  firstDateOfCurrentMonth,
  lastDateOfCurrentMonth,
} from "../Constants/dashboard";

export const checkMonth = (month: number, curStart: string, curEnd: string) => {
  const startMonth = new Date(curStart).getMonth() + 1;
  const endMonth = new Date(curEnd).getMonth() + 1;
  const res = {
    month: false,
    rightBorder: false,
    leftBorder: false,
  };
  if (month >= startMonth && endMonth >= month) {
    res.month = true;
  }
  if (month == startMonth) {
    res.leftBorder = true;
  }
  if (month == endMonth) {
    res.rightBorder = true;
  }
  return res;
};
export const scrollToTop = () => {
  window.scrollTo(0, 0);
};
export const checkDate = (date: number, curStart: string, curEnd: string) => {
  const startDate = new Date(curStart).getDate();
  const endDate = new Date(curEnd).getDate();
  const res = {
    date: false,
    rightBorder: false,
    leftBorder: false,
  };

  if (date >= startDate && endDate >= date) {
    res.date = true;
  }
  if (date == startDate) {
    res.leftBorder = true;
  }
  if (date == endDate) {
    res.rightBorder = true;
  }
  return res;
};

export const getDaysBetweenDates = (startDate: string, endDate: string) => {
  const start = new Date(startDate);
  const end = new Date(endDate);
  const dayArray = [];

  while (start <= end) {
    dayArray.push(start.getDate());
    start.setDate(start.getDate() + 1);
  }
  return dayArray;
};

export const getDateCalendarTableHeads = (daysList: number[]) => {
  const datesArray = [
    {
      id: "title",
      date: 0,
      label: "",
    },
  ];

  if (daysList.length) {
    for (let i = 0; i <= daysList.length; i++) {
      datesArray.push({
        id: "",
        label: daysList[i]?.toString(),
        date: daysList[i],
      });
    }
  } else {
    for (
      let day = dayjs(firstDateOfCurrentMonth).day();
      day <= dayjs(lastDateOfCurrentMonth).day();
      day++
    ) {
      datesArray.push({
        id: "",
        label: day.toString(),
        date: day,
      });
    }
  }

  return datesArray;
};
